export default __webpack_public_path__ + "static/media/lipa.dedc5f3a.jpg";